var map = {
	"./1@2x.png": 8005,
	"./2@2x.png": 9191,
	"./3@2x.png": 8758,
	"./4@2x.png": 2233,
	"./5@2x.png": 9150,
	"./6@2x.png": 3665,
	"./7@2x.png": 4890,
	"./8@2x.png": 3785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8490;